import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';
import DefaultIMG from "../../../../../assets/img/Homebrew Labs White.png";

import { 
  Character
} from "@dndModels";

import FileDropzone from "@components/input/FileDropzone";
import CenteredMenu from "@components/input/menus/CenteredMenu";

interface Props {
  character: Character;
}

export default function CharacterImageInput({
  character,
}: Props) {
  const [image_type, setImageType] = useState("Character");
  
  const onDrop = (acceptedFiles: File[]) => {
    console.log(acceptedFiles);
    if (acceptedFiles.length > 0) {
      const image = acceptedFiles[0];
      const data = new FormData();
      data.append("file", image);
      data.append("upload_preset", "o3zenvnq");
      data.append("cloud_name", "dojs5friw");
      fetch("https://api.cloudinary.com/v1_1/dojs5friw/image/upload", {
        method: "post",
        body: data
      })
        .then(resp => resp.json())
        .then(data => {
          const obj = character;
          if (image_type === "Character") {
            obj.image_url = data.url;
          } else {
            obj.bg_image_url = data.url;
          }
          character.changed();
        })
        .catch(err => console.log(err));
    }
  }
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <CenteredMenu
          options={["Character", "Background"]}
          selected={image_type}
          onSelect={setImageType}
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>&nbsp;</Grid>
      <Grid
        className="centered"
        size={{
          xs: 12
        }}>
        <img src={ image_type === "Character" ? (character.image_url === "" ? DefaultIMG : character.image_url) : (character.bg_image_url === "" ? DefaultIMG : character.bg_image_url) } alt="logo" 
          style={{
            maxWidth: "10em",
            maxHeight: "10em",
            border: "1px solid"
          }} 
        />
      </Grid>
      <Grid
        style={{ 
          padding: "0px"
        }}
        className="centered"
        size={{
          xs: 12
        }}>
        <FileDropzone 
          label={`Drag 'n' drop new ${image_type} Image here` }
          accept={{'image/jpeg': [], 'image/png': []}} 
          onDrop={onDrop} 
        />
      </Grid>
    </Grid>
  );
}
